import React, { useState, ReactNode, useCallback } from 'react';
import { Icon } from './Icon';

interface HelpPopProps {
    text?: string;
    children?: ReactNode;
    className?: string;
}

export function HelpPop(props: HelpPopProps) {
    const { text, children } = props;
    const [expanded, setExpanded] = useState(false);

    const className = `help-accordion slide ${expanded ? 'collapse show d-block border border-light-2' : 'collapse'}`;

    const handleExpandClick = useCallback(
        function (e: React.MouseEvent<HTMLElement>) {
            e.preventDefault();
            e.stopPropagation();

            setExpanded(!expanded);
        },
        [expanded]
    );

    return (
        <>
            <button className={`btn-text ${props.className ?? ''}`} onClick={handleExpandClick} type="button">
                <Icon name="question-circle" className="help-pop" aria-hidden="true" />
            </button>
            {expanded && (
                <span className={className} role="tabpanel">
                    {text || children}
                </span>
            )}
        </>
    );
}
